import moment from 'jalali-moment';

export const descriptionHelper = (
  title: string,
  cardTitle: string,
  data: IUserPromotedAdverstismentData,
): JSX.Element => {
  const Converteddata: Record<string, JSX.Element> = {
    'ارسال پیامک': (
      <div className="flex flex-col w-full">
        <p>آگهی {cardTitle} برای خریداران ، بصورت پیامک ارسال شد.</p>
        {data?.count_sms?.delivered_sms !== null &&
          data?.count_sms?.future_sms !== null && (
            <div className="flex justify-between items-center">
              <p>پیامک‌های ارسال شده {data?.count_sms?.delivered_sms}</p>
              <p>پیامک‌های باقی‌مانده {data?.count_sms?.future_sms}</p>
            </div>
          )}
      </div>
    ),
    'تازه سازی': (
      <div className="flex flex-col w-full">
        <p>
          آگهی {cardTitle} به تاریخ
          {moment(moment(data?.created_at))
            .locale('fa')
            .format('YYYY/MM/DD')}{' '}
          منتشر شد و در ابتدای لیست قرار گرفت.
        </p>
      </div>
    ),
  };
  return title in Converteddata ? Converteddata[title] : <></>;
};
